import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "dataForm",
  style: {"min-width":"800px"}
}
const _hoisted_2 = { class: "underlineForm" }
const _hoisted_3 = {
  key: 2,
  class: "mb-20 fullWidth"
}
const _hoisted_4 = {
  key: 0,
  class: "dialog-footer mt-20"
}
const _hoisted_5 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_PurchaseAdvanceList = _resolveComponent("PurchaseAdvanceList")!
  const _component_MaterialList = _resolveComponent("MaterialList")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "dataForm",
      model: _ctx.ruleForm,
      rules: _ctx.rules,
      "label-position": "top",
      "label-width": "100px",
      class: "mb-20",
      disabled: _ctx.formDisabled
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_form_item, {
            label: "供应商",
            prop: "supplierId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                filterable: true,
                modelValue: _ctx.ruleForm.supplierId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ruleForm.supplierId) = $event)),
                class: "filter-item",
                placeholder: "输入关键字搜索",
                clearable: "",
                remote: "",
                onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.supplierRemoteMethod(''))),
                "remote-method": query => _ctx.supplierRemoteMethod(query)
              }, {
                default: _withCtx(() => [
                  (_ctx.supplierption.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.supplierption, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.mark,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    : (_openBlock(), _createBlock(_component_el_option, {
                        key: 1,
                        value: -1,
                        disabled: ""
                      }, {
                        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                          _createTextVNode("暂无数据", -1)
                        ]))]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["modelValue", "remote-method"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "供应商账户",
            prop: "account"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                filterable: true,
                modelValue: _ctx.ruleForm.account,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ruleForm.account) = $event)),
                class: "filter-item",
                placeholder: "输入关键字搜索",
                clearable: "",
                "value-key": "alias",
                onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.supplierAccountRemoteMethod()))
              }, {
                default: _withCtx(() => [
                  (_ctx.supplierAccountOption.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.supplierAccountOption, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id || index,
                          label: item.alias,
                          value: item
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    : (_openBlock(), _createBlock(_component_el_option, {
                        key: 1,
                        value: -1,
                        disabled: ""
                      }, {
                        default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                          _createTextVNode(" 暂无数据 ", -1)
                        ]))]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "是否含税",
            prop: "containsRate"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                filterable: true,
                modelValue: _ctx.ruleForm.containsRate,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ruleForm.containsRate) = $event)),
                class: "filter-item",
                placeholder: "输入关键字搜索",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  (_ctx.containsRateOption.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.containsRateOption, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    : (_openBlock(), _createBlock(_component_el_option, {
                        key: 1,
                        value: -1,
                        disabled: ""
                      }, {
                        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                          _createTextVNode("暂无数据", -1)
                        ]))]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (_ctx.ruleForm.containsRate)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_el_form_item, {
                  label: "税率",
                  prop: "rate"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      filterable: true,
                      modelValue: _ctx.ruleForm.rate,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.ruleForm.rate) = $event)),
                      class: "filter-item",
                      placeholder: "输入关键字搜索",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_ctx.rateOption.length)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.rateOption, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.mark,
                                value: item.rate
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          : (_openBlock(), _createBlock(_component_el_option, {
                              key: 1,
                              value: -1,
                              disabled: ""
                            }, {
                              default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                _createTextVNode("暂无数据", -1)
                              ]))]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "发票类型",
                  prop: "invoiceType"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      filterable: true,
                      modelValue: _ctx.ruleForm.invoiceType,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ruleForm.invoiceType) = $event)),
                      class: "filter-item",
                      placeholder: "输入关键字搜索",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_ctx.invoiceTypeOption.length)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.invoiceTypeOption, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.mark,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          : (_openBlock(), _createBlock(_component_el_option, {
                              key: 1,
                              value: -1,
                              disabled: ""
                            }, {
                              default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                _createTextVNode("暂无数据", -1)
                              ]))]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: "付款周期",
            prop: "payCycleId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                filterable: true,
                modelValue: _ctx.ruleForm.payCycleId,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.ruleForm.payCycleId) = $event)),
                class: "filter-item",
                placeholder: "输入关键字搜索",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  (_ctx.payCycleOption.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.payCycleOption, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    : (_openBlock(), _createBlock(_component_el_option, {
                        key: 1,
                        value: -1,
                        disabled: ""
                      }, {
                        default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                          _createTextVNode("暂无数据", -1)
                        ]))]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "发货方式",
            prop: "deliveryId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                filterable: true,
                modelValue: _ctx.ruleForm.deliveryId,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.ruleForm.deliveryId) = $event)),
                class: "filter-item",
                placeholder: "输入关键字搜索",
                clearable: "",
                onChange: _ctx.handleDeliveryChange
              }, {
                default: _withCtx(() => [
                  (_ctx.deliveryOption.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.deliveryOption, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    : (_openBlock(), _createBlock(_component_el_option, {
                        key: 1,
                        value: -1,
                        disabled: ""
                      }, {
                        default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                          _createTextVNode("暂无数据", -1)
                        ]))]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ]),
            _: 1
          }),
          (_ctx.isShowExpress)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 1,
                label: "发货快递",
                prop: "expressId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    filterable: true,
                    modelValue: _ctx.ruleForm.expressId,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.ruleForm.expressId) = $event)),
                    class: "filter-item",
                    placeholder: "输入关键字搜索",
                    clearable: ""
                  }, {
                    default: _withCtx(() => [
                      (_ctx.expressOption.length)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.expressOption, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: item.name,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        : (_openBlock(), _createBlock(_component_el_option, {
                            key: 1,
                            value: -1,
                            disabled: ""
                          }, {
                            default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                              _createTextVNode("暂无数据", -1)
                            ]))]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: "备注",
            prop: "mark",
            class: "fullWidth"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.ruleForm.mark,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.ruleForm.mark) = $event)),
                type: "textarea",
                class: "filter-item",
                clearable: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (_ctx.mode !== 'approval')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_el_button, {
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleAddComand('purchaseAdvance'))),
                  type: "primary"
                }, {
                  default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                    _createTextVNode(" 添加预采购 ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleAddComand('material'))),
                  type: "primary"
                }, {
                  default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                    _createTextVNode(" 添加物料 ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_el_button, { onClick: _ctx.handleRemoveComand }, {
                  default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                    _createTextVNode(" 移除 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table, {
            data: _ctx.ruleForm.details,
            border: "",
            fit: "",
            "row-key": "materialId",
            class: "fullWidth",
            "header-cell-style": { background: '#ddd', color: 'rgba(0,0,0,0.9)' },
            "span-method": _ctx.objectSpanMethod,
            onSelectionChange: _ctx.handleTableSelect,
            "summary-method": _ctx.getSummaries,
            "show-summary": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                type: "selection",
                width: "55",
                fixed: ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "amount",
                label: "数量",
                fixed: "",
                "min-width": "120"
              }, {
                default: _withCtx(({ row }) => [
                  _createVNode(_component_el_input, {
                    modelValue: row.amount,
                    "onUpdate:modelValue": ($event: any) => ((row.amount) = $event),
                    type: "number",
                    min: 0,
                    onInput: _ctx.handleCalcTotal
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "fee",
                label: "单价",
                fixed: "",
                "min-width": "160"
              }, {
                default: _withCtx(({ row }) => [
                  _createVNode(_component_el_input_number, {
                    modelValue: row.fee,
                    "onUpdate:modelValue": ($event: any) => ((row.fee) = $event),
                    type: "number",
                    min: 0,
                    onInput: _ctx.handleCalcTotal,
                    precision: 2,
                    "controls-position": "right"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "materialNo",
                label: "物料编号",
                "min-width": "160"
              }),
              _createVNode(_component_el_table_column, {
                prop: "materialName",
                label: "物料名称",
                "min-width": "100"
              }),
              _createVNode(_component_el_table_column, {
                prop: "materialBrand",
                label: "物料品牌",
                "min-width": "100"
              }),
              _createVNode(_component_el_table_column, {
                prop: "materialModel",
                label: "物料型号",
                "min-width": "100"
              }),
              _createVNode(_component_el_table_column, {
                prop: "materialUnit",
                label: "物料单位",
                "min-width": "100"
              }),
              _createVNode(_component_el_table_column, {
                prop: "materialStandard",
                label: "封装规格"
              }),
              _createVNode(_component_el_table_column, {
                prop: "materialCreateUser",
                label: "申请人",
                "min-width": "110"
              }),
              _createVNode(_component_el_table_column, {
                prop: "materialAmount",
                label: "申请数量",
                "min-width": "100"
              }),
              _createVNode(_component_el_table_column, {
                prop: "max",
                label: "最高价",
                "show-overflow-tooltip": "",
                "min-width": "120"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.material?.max)
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 0,
                        effect: "dark",
                        placement: "top-start"
                      }, {
                        content: _withCtx(() => [
                          _createTextVNode(_toDisplayString(scope.row.material?.max?.supplier?.name), 1),
                          _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
                          _createTextVNode(" 最后修改时间：" + _toDisplayString(scope.row.material?.max?.updateTime), 1)
                        ]),
                        default: _withCtx(() => [
                          _cache[27] || (_cache[27] = _createElementVNode("i", {
                            class: "iconfont icon-tubiao-30",
                            style: {"font-size":"14px"}
                          }, null, -1))
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.maxMinCalc(scope.row.material, 'max')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "min",
                label: "最低价",
                "show-overflow-tooltip": "",
                "min-width": "120"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.material?.min)
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 0,
                        effect: "dark",
                        placement: "top-start"
                      }, {
                        content: _withCtx(() => [
                          _createTextVNode(_toDisplayString(scope.row.material?.min?.supplier?.name), 1),
                          _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
                          _createTextVNode(" 最后修改时间：" + _toDisplayString(scope.row.material?.min?.updateTime), 1)
                        ]),
                        default: _withCtx(() => [
                          _cache[29] || (_cache[29] = _createElementVNode("i", {
                            class: "iconfont icon-tubiao-30",
                            style: {"font-size":"14px"}
                          }, null, -1))
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.maxMinCalc(scope.row.material, 'min')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "total",
                label: "合计",
                fixed: "right",
                "min-width": "100"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.numberTimes(row.fee, row.amount, true)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data", "span-method", "onSelectionChange", "summary-method"])
        ])
      ]),
      _: 1
    }, 8, ["model", "rules", "disabled"]),
    (_ctx.mode !== 'approval')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_el_button, { onClick: _ctx.cancle }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            loading: _ctx.submitLoading,
            onClick: _ctx.handleSubmit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.confirm")), 1)
            ]),
            _: 1
          }, 8, ["loading", "onClick"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.dialogVisible)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 1,
          modelValue: _ctx.dialogVisible,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.dialogVisible) = $event)),
          title: _ctx.addType === 'purchaseAdvance' ? '预采购列表' : '物料列表',
          width: "80%"
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_el_button, {
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.dialogVisible = false)),
                type: "danger"
              }, {
                default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                  _createTextVNode("取消", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.handleAdd
              }, {
                default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                  _createTextVNode("确定", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            (_ctx.addType === 'purchaseAdvance')
              ? (_openBlock(), _createBlock(_component_PurchaseAdvanceList, {
                  key: 0,
                  mode: "table",
                  ref: "PurchaseAdvanceList",
                  excludeIds: _ctx.getexcludeIds(),
                  statusIn: 0
                }, null, 8, ["excludeIds"]))
              : (_openBlock(), _createBlock(_component_MaterialList, {
                  key: 1,
                  ref: "MaterialList",
                  excludeIds: _ctx.getexcludeIds()
                }, null, 8, ["excludeIds"]))
          ]),
          _: 1
        }, 8, ["modelValue", "title"]))
      : _createCommentVNode("", true)
  ]))
}